import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import CasesAPI, { CreateCaseRequest, CreateCaseResponse, GetCasesParams, GetCasesResponse } from "../../../api/cases";
import { RootState } from "../../../app/store";
import { toUTCDateString } from "../../../lib/utils";
import { CaseListFilters } from "./CaseFiltersSlice";

export const buildCaseFilterParams = (filters: CaseListFilters): GetCasesParams => ({
    uin: filters.searchStrings,
    referral_start_date: toUTCDateString(filters.referral_date_range.from),
    referral_end_date: toUTCDateString(filters.referral_date_range.to),
    investigator_id: filters.investigator_id,
    zone: filters.zone,
    status: filters.status,
    area_of_fraud: filters.area_of_fraud,
});

export const createCase = createAsyncThunk<
    CreateCaseResponse, 
    CreateCaseRequest,
    {rejectValue: void}
>(
    'cases/createCase',
    async (request, {rejectWithValue}) => {
        try{
            return await CasesAPI.create(request);
        } catch(error) {
            console.error(error);
            return rejectWithValue()
        }
    }
)

export const fetchCases = createAsyncThunk<
    GetCasesResponse, 
    void, 
    {state: RootState, rejectValue: void}
>(
    "configs/fetchCases",
    async (_, { getState, rejectWithValue, signal }) => {
        try{

            const cancelTokenSource = axios.CancelToken.source();
            signal.addEventListener('abort', () => {
                cancelTokenSource.cancel()
            });

            const state: RootState = getState();
            const filters = state.caseFilters;

            const params: GetCasesParams = {
                ...buildCaseFilterParams(filters),
                page_size: filters.page_size,
                page_number: filters.page_number
            }
            return await CasesAPI.get(params, cancelTokenSource);
            
        } catch(error) {
            console.error(error);
            return rejectWithValue();
        }
    }
)
